import { DataType, GeckoMeasurementUnit } from 'types'

export const MAX_CATEGORICAL_FILTER_VALUES = 7

export function categoricalValueFilterState(
  measurementUnit: GeckoMeasurementUnit,
  selectedValues: readonly number[] | undefined
): { storedCount: number; allowedValues: readonly number[] } {
  if (
    measurementUnit.dataType !== DataType.Categorical ||
    selectedValues === undefined
  ) {
    return { storedCount: -1, allowedValues: [] }
  }

  if (selectedValues.length === 0) {
    return { storedCount: 0, allowedValues: [] }
  }

  const allowedValues = selectedValues.slice(0, MAX_CATEGORICAL_FILTER_VALUES)
  return { storedCount: allowedValues.length, allowedValues }
}
